// @ts-strict-ignore
import {Component, computed, effect, ElementRef, input, OnInit, viewChild} from "@angular/core";
import {SimConfigurationService, SimUtilityService} from "@services";
import {EventEmitterService} from "@event-emitter";
import {IVideoScreen, PlaybackCameraLayoutOptions} from "@models";
import {Translations} from "@translations";
import {TranslateService} from "@ngx-translate/core";

@Component({
	selector: "sim-recording-archive-camera",
	templateUrl: "./recording-archive-camera.component.html",
	styleUrls: ["./recording-archive-camera.component.scss"],
	providers: [EventEmitterService],
	standalone: false,
})
export class RecordingArchiveCameraComponent implements OnInit {
	T = Translations;
	public settings = SimConfigurationService.settings;

	readonly screen = input<IVideoScreen>();
	readonly cameraLayoutOptions = input<PlaybackCameraLayoutOptions>();

	public readonly videoElementRef = viewChild<ElementRef<HTMLVideoElement>>("videoPlayer");

	public screenId: string = null;
	public isCinemaModeActive: boolean = false;

	public readonly posterUrl = computed(() => this.screen().url.replace("/api/stream/", "/api/poster/"));

	constructor(
		private _emitterService: EventEmitterService,
		public translate: TranslateService,
	) {
		effect(() => {
			this.screen().setVideoElementRef(this.videoElementRef);
		});
	}

	ngOnInit() {
		this.screenId = SimUtilityService.createGuid();

		this._emitterService.onSelectedFullScreenChanged.subscribe((args) => {
			if (this.screen()) {
				let newFullScreen: "self" | "other" | "none" = "none";

				if (!!args.currentFullScreen) {
					if (args.currentFullScreen === this.screen()) {
						newFullScreen = "self";
					} else {
						newFullScreen = "other";
					}
				}

				this.screen().isHidden = newFullScreen === "other";
				this.screen().isFullScreen = newFullScreen === "self";
			}
		});
	}

	public get imageUrl(): string {
		if (!this.screen() || this.screen().mediaType !== "streamable") {
			return this.settings.noVideoUrl;
		}
		return this.settings.waitingForVideoUrl;
	}

	public setError($event: ErrorEvent) {
		console.error($event.currentTarget);

		if (this.screen()) {
			this.screen().mediaType = "picture";
			this.screen().url = this.settings.noVideoUrl;
		}
	}

	public handleScreenClick() {
		if (this.cameraLayoutOptions()?.enableControl ?? true) {
			if (this.cameraLayoutOptions()?.cameraLayoutType == null || this.cameraLayoutOptions()?.cameraLayoutType) {
				if (this.screen()) {
					if (!this.screen().isFullScreen) {
						this._emitterService.onSelectedFullScreenChanged.next({
							currentFullScreen: this.screen(),
						});
						this.isCinemaModeActive = true;
					} else {
						this._emitterService.onSelectedFullScreenChanged.next({
							currentFullScreen: null,
						});
						this.isCinemaModeActive = false;
					}
				}
			}
		}
	}

	public onEnded() {
		if (this.screen()?.onEnded && this.screen()?.isSynchronizationMaster) {
			this.screen().onEnded();
		}
	}
}
